import moment from "moment";
import { useEffect, useState } from "react";
import { Toaster, toast } from "react-hot-toast";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import { components } from "react-select";
import {
  CheckUniquiEmailAndMobilePayloadType,
  GetAllFinacUserPayloadType,
} from "../../../commonTypes/authTypes";
import { DropDownType, GetClientDirectoryListPayloadType } from "../../../commonTypes/clientDirectoryTypes";
import {
  GetCityListDataPayloadType,
  GetCountryListDataPayloadType,
  GetEmailerDataPayloadType,
  GetMasterDataListPayloadType,
  GetStateListDataPayloadType,
  GetUsersDepartmentPayloadType,
} from "../../../commonTypes/masterDataTypes";
import {
  getBankAccountNumberType,
  verifyPanType,
} from "../../../commonTypes/serviceTypes";
import { OptionsType } from "../../../commonTypes/universalTypes";
import { GetAllUserGroupPayloadType } from "../../../commonTypes/userManagementTypes";
import { CheckUniquiAadharPanPayloadType } from "../../../commonTypes/usersProfileTypes";
import BankIdDetails from "../../../components/AddUsers/BankIdDetails";
import JobDetails from "../../../components/AddUsers/JobDetails";
import WorkDetails from "../../../components/AddUsers/Settings";
import AllUserDetails from "../../../components/AddUsers/UserDetails";
import { UserListType } from "../../../components/DisbursementModule/DisbursementModuleForm/AddEditDisbursementForm";
import {
  CircularAvatar,
  CommonHeader,
  ErrorSuccessModal,
  Loader,
} from "../../../components/commons";
import useDebounce from "../../../customHooks/useDebounce";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";
import {
  checkUniqueEmailAction,
  checkUniqueMobileNoAction,
  getAllFinacUsersAction,
  resetAuthError,
  resetAuthSuccess,
  resetEmailError,
  resetEmailFetching,
  resetEmailMessage,
  resetIsEmail,
  resetIsMobileNo,
  resetMobileError,
  resetMobileFetching,
  resetMobileMessage,
  resetSession,
} from "../../../redux/auth";
import { FinacUsersType, UserProfileType } from "../../../redux/auth/authTypes";
import { getClientDirectoryListAction } from "../../../redux/clientDirectory";
import { ClientDirectoryListType } from "../../../redux/clientDirectory/clientDirectoryType";
import {
  resetFixedAssetRegisterListing,
  resetFixedAssetRegisterTotalCount,
} from "../../../redux/fixedAsset";
import { getFixedAssetRegisterListing } from "../../../redux/fixedAsset/actions";
import {
  getAllCityAction,
  getAllCityPermanentAddressAction,
  getAllCountryAction,
  getAllStateAction,
  getAllStatePermanentAddressAction,
  getMasterDataEmailersAction,
  getMasterDataSkillsModuleAction,
  getMasterDataUsersDepartmentAction,
  resetCityList,
  resetCityListPermanentAddress,
  resetEmailerList,
  resetSkillMasterDataList,
  resetSkillsMasterDataTotalCount,
  resetStateList,
} from "../../../redux/masterData";
import {
  CityListTypes,
  CountryListTypes,
  MasterEmailerList,
  skillMasterDataListType,
  StateListTypes,
} from "../../../redux/masterData/masterTypes";
import { RootState } from "../../../redux/rootReducers";
import {
  getBankAccountInfoAction,
  resetBankAccountDetails,
  resetPanVerifyData,
  resetServicesError,
  verifyPanAction,
} from "../../../redux/services";
import {
  BankAccountInfoType,
  PanVerifyType,
} from "../../../redux/services/serviceTypes";
import {
  getAllUserGroupsAction,
  resetUserGroupList,
  resetUserManagementError,
  resetUserManagementStatusCode,
  resetUserManagementSuccess,
} from "../../../redux/userManagement";
import { UserGrouptype } from "../../../redux/userManagement/userManagementTypes";
import {
  resetAaddharSuccess,
  resetAadhaarError,
  resetAadhaarMessage,
  resetPanError,
  resetPanMessage,
  resetPanSuccess,
  resetPassportError,
  resetPassportMessage,
  resetPassportSuccess,
  resetStatusCodeAadhaar,
  resetStatusCodePan,
  resetStatusCodePassport,
  resetStatusCodeUan,
  resetUanError,
  resetUanMessage,
  resetUsersProfileError,
  resetUsersProfileSuccess,
} from "../../../redux/usersProfile";
import {
  addUserPofile,
  checkUniqueAadharAction,
  checkUniquePanAction,
  checkUniquePassportAction,
  checkUniqueUanAction,
} from "../../../redux/usersProfile/actions";
import {
  convertPasswordToHash,
  formatDate,
  isEmailValid,
  reverseDate,
} from "../../../utils/commonFunctions";
import { accordianJobDetails } from "../AllUserProfileEdit";
import UsersSettings from "../../../components/AddUsers/UserSettings";

let formTabs: TabsType[] = [
  {
    name: "Basic Details",
    label: "basic",
    display: false,
    key: "basic",
  },
  {
    name: "HR Settings",
    label: "hrsettings",
    display: false,
    key: "hr",
  },
  {
    name: "Job Details",
    label: "job",
    display: false,
    key: "job",
  },
  {
    name: "Payroll settings",
    label: "bankid",
    display: false,
    key: "payroll",
  },
  {
    name: "User settings",
    label: "userSetting",
    display: false,
    key: "userSetting",
  },
];

type userListType = {
  value: number | undefined;
  label: string | undefined;
};
interface TabsType {
  name: string;
  label: string;
  display: boolean;
  key: string;
}
type PasswordResultType = {
  least: boolean;
  uppercase: boolean;
  special: boolean;
  lower: boolean;
  number: boolean;
};

type UniqueEmailType = {
  token: string | null;
  operation: string | null;
  email: string | null | undefined;
};
type UniqueMobileNoType = {
  token: string | null;
  operation: string | null;
  mobile: number | null | undefined;
};

type AppProps = {
  history: any;
  fetching: boolean;
  servicesFetching: boolean;
  token: string | null;
  dispatchResetSession: () => void;
  success: number | null;
  statusCode: number | null;
  error: string | null;
  emailMessage: string | null;
  emailFetching: boolean;
  isEmail: number | null;
  mobileMessage: string | null;
  mobileFetching: boolean;
  isMobileNo: number | null;
  dispatchResetAuthError: () => void;
  dispatchAddUser: (data: any) => void;
  message: null | string;
  dispatchResetAuthSuccess: () => void;
  dispatchGetAllUserGroupsAction: (data: GetAllUserGroupPayloadType) => void;
  dispatchCheckUniqueEmailAction: (
    data: CheckUniquiEmailAndMobilePayloadType
  ) => void;
  dispatchCheckUniqueMobileNoAction: (
    data: CheckUniquiEmailAndMobilePayloadType
  ) => void;
  userGroupCount: number | string | any;
  userGroupList: [] | UserGrouptype[];
  dispatchResetUserManagementError: () => void;
  dispatchResetUserManagementSuccess: () => void;
  fetchingUser: boolean;
  dispatchResetUserGroupList: () => void;
  dispatchResetUserManagementStatusCode: () => void;
  successUserManagement: number | null;
  statusCodeUserManagement: number | null;
  errorUserManagement: string | null;
  dispatchResetEmailError: () => void;
  dispatchResetEmailMessage: () => void;
  dispatchResetEmailFetching: () => void;
  dispatchResetIsEmail: () => void;
  dispatchResetMobileError: () => void;
  dispatchResetMobileMessage: () => void;
  dispatchResetMobileFetching: () => void;
  dispatchResetIsMobileNo: () => void;
  dispatchResetUsersProfileSuccess: () => void;
  dispatchResetUsersProfileError: () => void;
  dispatchCheckUniqueAadhaarAction: (
    data: CheckUniquiAadharPanPayloadType
  ) => void;
  dispatchCheckUniqueUanAction: (data: CheckUniquiAadharPanPayloadType) => void;
  aadhaarFetching: boolean;
  aadhaarSuccess: number | null;
  aadhaarMessage: null | string;
  aadhaarError: null | string;
  isAadhaarNo: null | number;
  dispatchCheckUniquePanAction: (data: CheckUniquiAadharPanPayloadType) => void;
  dispatchCheckUniquePassportAction: (
    data: CheckUniquiAadharPanPayloadType
  ) => void;
  panFetching: boolean;
  panSuccess: number | null;
  panMessage: null | string;
  panError: null | string;
  isPanNo: null | number;
  passportFetching: boolean;
  passportMessage: null | string;
  isPassportNo: null | number;
  uanFetching: boolean;
  uanMessage: null | string;
  isUanNo: null | number;
  statusCodeAadhaar: null | number;
  statusCodePan: null | number;
  clientDirectoryList: [] | ClientDirectoryListType[];
  clientFetching: boolean;
  totalCount: number | null;
  finacUsersList: any;
  emailerList: MasterEmailerList[] | [];
  emailListTotalCount: number;
  countryList: CountryListTypes[] | [];
  countryListTotalCount: number;
  countryFetching: boolean;
  stateList: StateListTypes[] | [];
  stateListTotalCount: number;
  stateFetching: boolean;
  isState: null | boolean;
  cityList: CityListTypes[] | [];
  cityListTotalCount: number;
  isCity: null | boolean;
  stateListPermanentAddress: StateListTypes[] | [];
  stateListTotalCountPermanentAddress: number;
  stateFetchingPermanentAddress: boolean;
  isStatePermanentAddress: null | boolean;
  cityListPermanentAddress: CityListTypes[] | [];
  cityListTotalCountPermanentAddress: number;
  cityFetchingPermanentAddress: boolean;
  isCityPermanentAddress: null | boolean;
  finacAssetListing: [];
  finacAssetTotalCount: number;
  panVerifyDetails: PanVerifyType | null;
  dispatchResetFixedAssetRegisterListing: () => void;
  dispatchGetFixedAssetRegisterListing: (data: any) => void;
  dispatchResetFixedAssetRegisterTotalCount: () => void;
  dispatchResetPanMessage: () => void;
  dispatchResetPanError: () => void;
  dispatchResetStatusCodePan: () => void;
  dispatchResetAadhaarMessage: () => void;
  dispatchResetAadhaarError: () => void;
  dispatchResetStatusCodeAadhaar: () => void;
  dispatchResetPanSuccess: () => void;
  dispatchResetAaddharSuccess: () => void;
  dispatchResetPassportMessage: () => void;
  dispatchResetPassportError: () => void;
  dispatchResetStatusCodePassport: () => void;
  dispatchResetPassportSuccess: () => void;
  dispatchResetUanMessage: () => void;
  dispatchResetUanError: () => void;
  dispatchResetStatusCodeUan: () => void;
  dispatchResetUanSuccess: () => void;
  dispatchGetClientDirectoryListAction: (
    data: GetClientDirectoryListPayloadType
  ) => void;
  dispatchResetMasterDataEmailerListing: () => void;
  dispatchGetMasterDataEmailers: (data: GetEmailerDataPayloadType) => void;
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void;
  dispatchGetCountryListAction: (data: GetCountryListDataPayloadType) => void;
  dispatchGetAllStateAction: (data: GetStateListDataPayloadType) => void;
  dispatchGetAllStatePermanentAddressAction: (
    data: GetStateListDataPayloadType
  ) => void;
  dispatchGetAllCityAction: (data: GetCityListDataPayloadType) => void;
  dispatchResetStateList: () => void;
  dispatchResetCityList: () => void;
  dispatchResetCityListPermanentAddress: () => void;
  dispatchGetAllCityPermanentAddressAction: (
    data: GetCityListDataPayloadType
  ) => void;
  dispatchGetMasterDataUsersDepartmentAction: (
    data: GetUsersDepartmentPayloadType
  ) => void;
  userDepartmentList: any;
  usersDepartmentFetching: boolean;
  bankAccountDetails: BankAccountInfoType | null;
  dispatchGetBankAccountInfoAction: (data: getBankAccountNumberType) => void;
  dispatchVerifyPanAction: (data: verifyPanType) => void;
  dispatchResetBankAccountDetails: () => void;
  dispatchResetPanVerifyData: () => void;
  dispatchResetServicesError: () => void;
  servicesError: string | null;
  dispatchGetMasterDataSkillsModuleAction: (
    data: GetMasterDataListPayloadType
  ) => void;
  dispatchResetSkillMasterDataList: () => void;
  dispatchResetSkillsMasterDataTotalCount: () => void;
  skillMasterDataList: skillMasterDataListType[] | [];
  skillsMasterDataTotalCount: number;
  skillFetching: boolean;

};

const AddInternalExternalUser = ({
  history,
  token,
  fetching,
  dispatchResetSession,
  success,
  statusCode,
  error,
  dispatchResetAuthError,
  dispatchAddUser,
  message,
  dispatchResetAuthSuccess,
  dispatchGetAllUserGroupsAction,
  userGroupCount,
  userGroupList,
  dispatchResetUserManagementError,
  dispatchResetUserManagementSuccess,
  fetchingUser,
  dispatchResetUserGroupList,
  dispatchResetUserManagementStatusCode,
  statusCodeUserManagement,
  successUserManagement,
  errorUserManagement,
  dispatchCheckUniqueEmailAction,
  dispatchCheckUniqueMobileNoAction,
  emailMessage,
  emailFetching,
  isEmail,
  mobileMessage,
  mobileFetching,
  isMobileNo,
  countryList,
  countryFetching,
  countryListTotalCount,
  stateList,
  stateListTotalCount,
  stateFetching,
  isState,
  cityList,
  cityListTotalCount,
  isCity,
  stateListPermanentAddress,
  stateListTotalCountPermanentAddress,
  isStatePermanentAddress,
  stateFetchingPermanentAddress,
  cityListPermanentAddress,
  cityListTotalCountPermanentAddress,
  isCityPermanentAddress,
  cityFetchingPermanentAddress,
  panVerifyDetails,
  dispatchCheckUniqueUanAction,
  dispatchResetEmailError,
  dispatchResetEmailMessage,
  dispatchResetEmailFetching,
  dispatchResetIsEmail,
  dispatchResetMobileError,
  dispatchResetMobileMessage,
  dispatchResetMobileFetching,
  dispatchResetIsMobileNo,
  dispatchResetPassportMessage,
  dispatchResetPassportError,
  dispatchResetStatusCodePassport,
  dispatchResetPassportSuccess,
  dispatchResetUsersProfileError,
  dispatchResetUsersProfileSuccess,
  dispatchCheckUniqueAadhaarAction,
  dispatchGetFixedAssetRegisterListing,
  dispatchResetFixedAssetRegisterTotalCount,
  finacAssetListing,
  aadhaarFetching,
  aadhaarSuccess,
  aadhaarMessage,
  aadhaarError,
  isAadhaarNo,
  dispatchCheckUniquePanAction,
  dispatchCheckUniquePassportAction,
  passportFetching,
  passportMessage,
  isPassportNo,
  uanFetching,
  uanMessage,
  isUanNo,
  panFetching,
  panSuccess,
  panMessage,
  panError,
  isPanNo,
  statusCodeAadhaar,
  statusCodePan,
  dispatchResetPanMessage,
  dispatchResetPanError,
  dispatchResetStatusCodePan,
  dispatchResetAadhaarMessage,
  dispatchResetAadhaarError,
  dispatchResetStatusCodeAadhaar,
  dispatchResetPanSuccess,
  dispatchResetAaddharSuccess,
  dispatchResetUanMessage,
  dispatchResetUanError,
  dispatchResetStatusCodeUan,
  dispatchResetUanSuccess,
  clientDirectoryList,
  clientFetching,
  totalCount,
  finacAssetTotalCount,
  dispatchGetClientDirectoryListAction,
  emailerList,
  emailListTotalCount,
  finacUsersList,
  dispatchResetMasterDataEmailerListing,
  dispatchGetMasterDataEmailers,
  dispatchGetAllFinacUsersAction,
  dispatchGetCountryListAction,
  dispatchGetAllStateAction,
  dispatchGetAllCityAction,
  dispatchResetStateList,
  dispatchResetCityList,
  dispatchGetAllStatePermanentAddressAction,
  dispatchGetAllCityPermanentAddressAction,
  dispatchResetCityListPermanentAddress,
  dispatchGetMasterDataUsersDepartmentAction,
  dispatchResetFixedAssetRegisterListing,
  userDepartmentList,
  usersDepartmentFetching,
  servicesFetching,
  bankAccountDetails,
  dispatchGetBankAccountInfoAction,
  dispatchVerifyPanAction,
  dispatchResetBankAccountDetails,
  dispatchResetPanVerifyData,
  servicesError,
  dispatchResetServicesError,
  dispatchGetMasterDataSkillsModuleAction,
  dispatchResetSkillMasterDataList,
  dispatchResetSkillsMasterDataTotalCount,
  skillMasterDataList,
  skillsMasterDataTotalCount,
  skillFetching
}: AppProps) => {
  const { pathname } = useLocation();
  const [tabs, setTabs] = useState(formTabs);
  const [activeTab, setActiveTab] = useState(tabs[0].label);
  const [uploadData, setUploadData] = useState<any>([]);
  const [formMobileCountryCode, setMobileCountryCode] = useState("");
  const [formWhatsappCountryCode, setWhatsappCountryCode] = useState("");
  const [finalUserGroupList, setFinalUserGroupList] = useState<
    userListType[] | []
  >([]);
  const [clientSelected, setClientSelected] = useState({
    value: null,
    label: "select",
  });
  const [clientOffset, setClientOffset] = useState<number>(0);
  const clientLimit = 20;
  const [clientText, setClientText] = useState<string>("");
  const [access, setAccess] = useState(false);
  const [finalClientList, setFinalClientList] = useState<any>([]);
  const [newPassword, setNewPassword] = useState("");
  const [limit, setLimit] = useState(20);
  const [assetLimit, setAssetLimit] = useState(50);
  const [offset, setOffset] = useState(0);
  const [assignGroup, setAssignGroup] = useState("");
  const [searchClear, setSearchClear] = useState(false);
  const [sameAddress, setSameAddress] = useState(false);
  const [emailList, setEmailList] = useState<any>([]);
  const [emailerLimit, setEmailerLimit] = useState(50);
  const [emailerOffset, setEmailerOffset] = useState(0);
  const [emailerSearchValue, setEmailerSearchValue] = useState("");
  const [text, setText] = useState("");
  const [emailerText, setEmailerText] = useState("");
  const [finacUserLimit, setFinacUserLimit] = useState(20);
  const [finacUsersOffset, setfinacUsersOffset] = useState(0);
  const [finacApiCall, setFinacApiCall] = useState(false);
  const [finalUserList, setFinalUserList] = useState<UserListType[] | []>([]);
  const [accordianJobDetailsData, setAccordianJobDetailsData] = useState(
    JSON.parse(JSON.stringify(accordianJobDetails))
  );
  // country
  const [countrySelectedList, setCountrySelectedList] = useState<any>([]);
  const [countryoffset, setCountryOffset] = useState<number>(0);
  const [stateOffset, setStateOffset] = useState<number>(0);
  const [cityOffset, setCityOffset] = useState<number>(0);
  const [countrytext, setCountryText] = useState<string>("");
  const [stateText, setStateText] = useState<string>("");
  const [cityText, setCityText] = useState<string>("");
  const [countrylimit, setCountryLimit] = useState<number>(20);
  const [loadCondition, setLoadCondition] = useState(true);
  const [finalStateAddressList, setFinalStateAddressList] = useState<any>([]);
  const [isApiAddressCall, setIsApiAddressCall] = useState(false);
  const [stateAddressText, setStateAddressText] = useState<string>("");
  const [stateAddressOffset, setStateAddressOffset] = useState<number>(0);
  const [finalCityAddressList, setFinalCityAddressList] = useState<any>([]);
  const [cityAddressText, setCityAddressText] = useState<string>("");
  const [cityAddressOffset, setCityAddressOffset] = useState<number>(0);
  const [isApiCityAddressCall, setIsApiCityAddressCall] = useState(false);
  const [usersDepartmentOffset, setUsersDepartmentOffset] = useState<number>(0);
  const [usersDepartmentText, setUsersDepartmentText] = useState<string>("");
  const [finalUsersDepartmentList, setFinalUsersDepartmentList] = useState<any>(
    []
  );
  const [finalFinacAssetList, setFinalFinacAssetList] = useState<any>([]);
  const [finacAssetText, setFinacAssetText] = useState<string>("");
  const [finacAssetOffset, setFinacAssetOffset] = useState<number>(0);
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const [finalCountry, setCountry] = useState<any>({
    value: null,
    label: "Select..",
  });
  const [skillsOffset, setSkillsOffset] = useState<number>(0);
  const [skillsText, setSkillsText] = useState<string>("");
  const [finalSkillList, setFinalSkillList] = useState<DropDownType[] | []>([]);

  // state
  const [addressState, setAddressState] = useState<OptionsType>({
    value: null,
    label: "Choose State...",
  });
  const [finalStateList, setFinalStateList] = useState<any>([]);
  const [isApiCall, setIsApiCall] = useState(false);
  const [isApiCityCall, setIsApiCityCall] = useState(false);
  const [selectedCityList, setSelectedCityList] = useState<any>({
    value: null,
    label: "Select...",
  });
  const [finalCityList, setFinalCityList] = useState<any>([]);

  const [uniqueEmail, setUniqueEmail] = useState<UniqueEmailType>({
    token,
    operation: "add",
    email: null,
  });
  const [uniqueMobileNo, setUniqueMobileNo] = useState<UniqueMobileNoType>({
    token,
    operation: "add",
    mobile: null,
  });

  const [uniqueAadhaarNo, setUniqueAadhaarNo] = useState<any>({
    token,
    operation: "add",
    aadhaar: null,
    role: "user",
  });

  const [uniquePassportNo, setUniquePassportNo] = useState<any>({
    token,
    operation: "add",
    passport: null,
    role: "user",
  });

  const [uniqueUanNo, setUniqueUanNo] = useState<any>({
    token,
    operation: "add",
    uan_no: null,
    role: "user",
  });

  const [uniquePanNo, setUniquePanNo] = useState<any>({
    token,
    operation: "add",
    pan: null,
    role: "user",
  });

  const [profileDetailsError, setProfileDetailsError] = useState({
    nameError: "",
    emailError: "",
    newPasswordError: "",
    newPasswordAgainError: "",
    countryError: "",
    stateError: "",
    cityError: "",
  });

  const [passwordResult, setPasswordResult] = useState<PasswordResultType>({
    least: false,
    uppercase: false,
    special: false,
    lower: false,
    number: false,
  });

  const [profileForm, setProfileForm] = useState<UserProfileType>({
    type: pathname.includes("internal-user") ? "employee" : "external_user",
    user_details: {
      profile_pic: null,
      basic_details: {
        first_name: "",
        last_name: "",
        email_id: "",
        access_details: {
          status: "",
          assigned_group: null,
          password: "",
        },
        skill: [],

      },
      personal_details: {
        gender: "",
        date_of_birth: "",
        blood_group: "",
        qualifications: "",
        mother_name: "",
        martial_status: "",
        spouse_name: "",
        father_or_husband_name: "",
        about_me: "",
      },
      current_address: {
        address_line1: "",
        address_line2: "",
        city: {
          value: null,
          label: "Select",
        },
        state: {
          value: null,
          label: "Select",
        },
        postal_code: "",
        country: {
          value: null,
          label: "Select",
        },
      },
      permanent_address: {
        address_line1: "",
        address_line2: "",
        city: {
          value: null,
          label: "Select",
        },
        state: {
          value: null,
          label: "Select",
        },
        postal_code: "",
        country: {
          value: null,
          label: "Select",
        },
      },
      contact_details: {
        personal_email_id: "",
        mobile: "",
        whatsapp_number: "",
        work_phone: "",
        emergency_contact_person: "",
        emergency_contact_number: "",
      },
      online_presence: {
        twitter_id: "",
        linkedin_profile: "",
      },
    },
    hr_settings: {
      leave_balance: null,
      work_from_home_balance: null,
      working_days: null,
      employment_status: "",
      is_govt_officer: false,
      work_details: {
        user_branch: null,
        // hourly_charge: "",
        // standard_hour: "",
        is_partner_field: "",
        is_manager_field: "",
        is_track_scheduling: "",
        is_track_efficiency: "",
      },
      enable_backdated_timesheet_entry: false,
    },
    job_details: [],
    payroll_settings: {
      identification_details: {
        passport_number: "",
        passport_expiry: "",
        adhar_number: "",
        pan: "",
        uan_number: "",
        entity_name: "",
        pan_details: null,
      },
      bank_account_details: [
        {
          bank_name: "",
          branch_name: "",
          bank_account_number: "",
          ifsc_code: "",
          account_type: "",
          bank_verification_details: null,
        },
      ],
      hourly_charge: "",
      standard_hour: "",
    },
    user_settings: {
      is_track_aproved_entries: false,
      total_target_entries: null,
      is_disable_user: false,
      is_track_timesheet_entry: true,
    },
  });

  const activeTabs = history?.location?.state;
  const [isHrSettingsTabPersent, setIsHrSettingsTabPersent] = useMenuCheck();
  const [isJobettingsTabPersent, setIsJobSettingsTabPersent] = useMenuCheck();
  const [isPayrollSettingsTabPersent, setIsPayrollSettingsTabPersent] =
    useMenuCheck();

  const [checkTest, setCheckList] = useState<any>({
    basic: true,
    hr: isHrSettingsTabPersent,
    job: isJobettingsTabPersent,
    payroll: isPayrollSettingsTabPersent,
    userSetting: pathname.includes("internal-user") ? true : false,
  });

  useEffect(() => {
    setIsHrSettingsTabPersent("HR Settings", "menu");
    setIsJobSettingsTabPersent("job Details", "menu");
    setIsPayrollSettingsTabPersent("Payroll Settings", "menu");
    dispatchResetAuthError();
    dispatchResetAuthSuccess();
    dispatchResetUserGroupList();
    dispatchResetUserManagementSuccess();
    dispatchResetUserManagementStatusCode();
    dispatchResetEmailError();
    dispatchResetEmailMessage();
    dispatchResetEmailFetching();
    dispatchResetIsEmail();
    dispatchResetMobileError();
    dispatchResetMobileMessage();
    dispatchResetMobileFetching();
    dispatchResetIsMobileNo();
    dispatchResetUsersProfileError();
    dispatchResetUsersProfileSuccess();
    dispatchResetPanMessage();
    dispatchResetPanError();
    dispatchResetStatusCodePan();
    dispatchResetPanSuccess();
    dispatchResetAadhaarMessage();
    dispatchResetAadhaarError();
    dispatchResetStatusCodeAadhaar();
    dispatchResetAaddharSuccess();
    dispatchResetPassportMessage();
    dispatchResetPassportError();
    dispatchResetStatusCodePassport();
    dispatchResetPassportSuccess();
    dispatchResetAaddharSuccess();
    dispatchResetUanMessage();
    dispatchResetUanError();
    dispatchResetStatusCodeUan();
    dispatchResetUanSuccess();
    dispatchResetBankAccountDetails();
    dispatchResetPanVerifyData();
    dispatchResetServicesError();
  }, []);

  useEffect(()=>{
    setCheckList({
      basic: true,
      hr: isHrSettingsTabPersent,
      job: isJobettingsTabPersent,
      payroll: isPayrollSettingsTabPersent,
      userSetting: pathname.includes("internal-user") ? true : false,
    });
  },[isHrSettingsTabPersent,isJobettingsTabPersent,isPayrollSettingsTabPersent,])

  useEffect(() => {
    const filterTabs = tabs.filter((el: TabsType) => {
      return checkTest[el.key] === true;
    });
    setTabs(filterTabs);
  }, [pathname,checkTest]);
 

  useEffect(() => {
    let temp = accordianJobDetailsData;
    let isDefaultPresent = temp?.filter((el: any) => el?.is_default === true);
    if (isDefaultPresent?.length === 0) {
      temp?.forEach((el: any, index: number) => {
        if (index === 0) {
          el.is_default = true;
        }
      });
      setAccordianJobDetailsData?.([...temp]);
    }
  }, [finacUsersList]);

  useEffect(() => {
    if (panVerifyDetails?.full_name) {
      setProfileForm((prv: UserProfileType) => {
        return {
          ...prv,
          payroll_settings: {
            ...prv.payroll_settings,
            identification_details: {
              ...prv.payroll_settings.identification_details,
              pan_details: { ...panVerifyDetails },
            },
          },
        };
      });
    } else {
      setProfileForm((prv: UserProfileType) => {
        return {
          ...prv,
          payroll_settings: {
            ...prv.payroll_settings,
            identification_details: {
              ...prv.payroll_settings.identification_details,
              pan_details: null,
            },
          },
        };
      });
    }
  }, [panVerifyDetails]);

  useEffect(() => {
    if (profileForm?.hr_settings?.employment_status === "Probation") {
      let temp = accordianJobDetailsData;
      temp?.forEach((el: any, index: number) => {
        if (el?.job_info?.start_date) {
          el["job_info"].probation_end_date = moment(el?.job_info?.start_date)
            .add(6, "months")
            .format("YYYY-MM-DD");
        }
      });
      setAccordianJobDetailsData?.([...temp]);
      // }
    }
  }, [profileForm?.hr_settings?.employment_status]);

  useEffect(() => {
    if (token) {
      if (offset < +userGroupCount) {
        let finalUserData = {
          token,
          offset,
          limit,
          search_term: assignGroup,
        };
        dispatchGetAllUserGroupsAction(finalUserData);
      }
      dispatchResetUserManagementError();
      dispatchResetUserManagementSuccess();
    }
  }, [offset]);

  // emailer List
  useEffect(() => {
    const newEmailListData = emailerList?.map((data: any) => {
      return {
        label: data?.email_name,
        value: data?._id,
      };
    });
    if (emailerList?.length === 0) {
      setEmailList(newEmailListData);
    }
    if (emailerOffset > 0) {
      setEmailList((prv: any) => [...prv, ...newEmailListData]);
    } else {
      setEmailList(newEmailListData);
    }
  }, [emailerList]);

  useDebounce(
    () => {
      if (emailerText) {
        fetchNewEmailerData();
      } else {
        let finalData: GetEmailerDataPayloadType = {
          token,
          limit: emailerLimit,
          offset: emailerOffset,
          searchValue: emailerText,
          status: true,
        };
        dispatchGetMasterDataEmailers(finalData);
      }
    },
    500,
    [emailerText]
  );

  useDebounce(
    () => {
      if (finacAssetText) {
        fetchFixedAssetNewData(finacAssetText);
      } else {
        setFinalFinacAssetList([]);
        dispatchResetFixedAssetRegisterListing();
        dispatchResetFixedAssetRegisterTotalCount();
        if (accordianJobDetailsData[activeTabIndex]?.job_info?.client) {
          let finalData = {
            token,
            client_code:
              accordianJobDetailsData[activeTabIndex]?.job_info?.client,
            limit: assetLimit,
            offset: 0,
            searchValue: "",
            is_assigned: 0,
          };
          dispatchGetFixedAssetRegisterListing(finalData);
        }
      }
    },
    500,
    [finacAssetText]
  );

  useEffect(() => {
    if (token) {
      if (accordianJobDetailsData[activeTabIndex]?.job_info?.client) {
        let finalData = {
          token,
          client_code:
            accordianJobDetailsData[activeTabIndex]?.job_info?.client,
          limit: assetLimit,
          offset: finacAssetOffset,
          searchValue: "",
          is_assigned: 0,
        };

        if (finacAssetTotalCount) {
          if (finacAssetOffset < finacAssetTotalCount) {
            dispatchGetFixedAssetRegisterListing(finalData);
          }
        } else {
          dispatchGetFixedAssetRegisterListing(finalData);
        }
      }
    }
  }, [finacAssetOffset]);

  useEffect(() => {
    if (token) {
      let finalData: GetEmailerDataPayloadType = {
        token,
        limit: emailerLimit,
        offset: emailerOffset,
        searchValue: emailerText,
        status: true,
      };
      if (emailListTotalCount) {
        if (emailerOffset < emailListTotalCount) {
          dispatchGetMasterDataEmailers(finalData);
        }
      } else {
        dispatchGetMasterDataEmailers(finalData);
      }
    }
  }, [emailerOffset]);

  const fetchNewEmailerData = () => {
    dispatchResetMasterDataEmailerListing();
    if (token) {
      let finalData = {
        token,
        limit: emailerLimit,
        offset: emailerOffset,
        searchValue: emailerText,
        status: true,
      };
      if (emailerOffset === 0) {
        dispatchGetMasterDataEmailers(finalData);
      } else {
        setEmailerOffset(0);
      }
    }
  };
  //

  //finac user
  useEffect(() => {
    if (finacUsersList?.data?.length) {
      let finalUserData = finacUsersList?.data?.map((user: FinacUsersType) => {
        return {
          value: user?.user_id,
          label: `${user?.first_name} ${user?.last_name}`,
          image: user?.profile_pic?.file_url,
        };
      });
      if (finacUsersOffset > 0) {
        setFinalUserList([...finalUserList, ...finalUserData]);
      } else {
        setFinalUserList([...finalUserData]);
      }
    }
  }, [finacUsersList?.data]);

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset: finacUsersOffset,
        limit: finacUserLimit,
        user_type: "stco_users",
        status: 1,
        search_term: text,
      };
      if (finacUsersOffset <= finacUsersList?.total_count && finacApiCall) {
        dispatchGetAllFinacUsersAction(finalUserData);
      }
    }
  }, [finacUsersOffset]);

  const fetchAllUsersNewData = (search: string) => {
    const finalData = {
      token,
      offset: finacUsersOffset,
      limit: finacUserLimit,
      user_type: "stco_users",
      status: 1,
      search_term: text,
    };
    dispatchGetAllFinacUsersAction(finalData);
  };

  const fetchFixedAssetNewData = (finacAssetText: string) => {
    setFinalFinacAssetList([]);
    dispatchResetFixedAssetRegisterListing();
    dispatchResetFixedAssetRegisterTotalCount();
    if (accordianJobDetailsData[activeTabIndex]?.job_info?.client) {
      let finalData = {
        token,
        client_code: accordianJobDetailsData[activeTabIndex]?.job_info?.client,
        limit: assetLimit,
        offset,
        searchValue: finacAssetText,
        is_assigned: 0,
      };
      dispatchGetFixedAssetRegisterListing(finalData);
    }
  };

  // Custom debounce hook for search data
  useDebounce(
    () => {
      if (text) {
        fetchAllUsersNewData(text);
      } else {
        setFinacApiCall(true);
        const finalData = {
          token,
          offset: finacUsersOffset,
          limit: finacUserLimit,
          user_type: "stco_users",
          status: 1,
          search_term: text,
        };
        dispatchGetAllFinacUsersAction(finalData);
      }
    },
    500,
    [text]
  );

  // client dropdown
  useEffect(() => {
    const finalClientListData = clientDirectoryList?.map((data: any) => {
      return {
        value: data?.client_code,
        label: `${data?.company_name}(${data?.client_code})`,
      };
    });
    if (clientOffset > 0) {
      setFinalClientList([...finalClientList, ...finalClientListData]);
    } else {
      setFinalClientList(finalClientListData);
    }
  }, [clientDirectoryList]);

  useEffect(() => {
    if (token && totalCount) {
      if (clientOffset <= +totalCount) {
        const finalData = {
          token,
          status: 1,
          offset: clientOffset,
          limit: clientLimit,
          searchValue: clientText,
        };
        dispatchGetClientDirectoryListAction(finalData);
      }
    }
  }, [clientOffset]);

  const fetchClientNewData = () => {
    const finalData = {
      token,
      status: 1,
      offset: clientOffset,
      limit: clientLimit,
      searchValue: clientText,
    };
    dispatchGetClientDirectoryListAction(finalData);
  };

  useDebounce(
    () => {
      if (clientText) {
        fetchClientNewData();
      } else {
        const finalData = {
          token,
          status: 1,
          offset: clientOffset,
          limit: clientLimit,
          searchValue: clientText,
        };
        dispatchGetClientDirectoryListAction(finalData);
      }
    },
    500,
    [clientText]
  );

  //Department List
  useEffect(() => {
    const finalDepartmentListData = userDepartmentList?.map((data: any) => {
      return {
        value: data?._id,
        label: `${data?.department_name}`,
      };
    });
    if (usersDepartmentOffset > 0) {
      setFinalUsersDepartmentList([
        ...finalUsersDepartmentList,
        ...finalDepartmentListData,
      ]);
    } else {
      setFinalUsersDepartmentList(finalDepartmentListData);
    }
  }, [userDepartmentList]);

  useEffect(() => {
    if (token && totalCount) {
      if (usersDepartmentOffset <= +totalCount) {
        const finalData = {
          token,
          status: 1,
          offset: usersDepartmentOffset,
          limit: clientLimit,
          searchValue: usersDepartmentText,
        };
        dispatchGetMasterDataUsersDepartmentAction(finalData);
      }
    }
  }, [usersDepartmentOffset]);

  const fetchUsersDepartmentNewData = () => {
    const finalData = {
      token,
      status: 1,
      offset: usersDepartmentOffset,
      limit: clientLimit,
      searchValue: usersDepartmentText,
    };
    dispatchGetMasterDataUsersDepartmentAction(finalData);
  };

  useDebounce(
    () => {
      if (usersDepartmentText) {
        fetchUsersDepartmentNewData();
      } else {
        const finalData = {
          token,
          status: 1,
          offset: usersDepartmentOffset,
          limit: clientLimit,
          searchValue: usersDepartmentText,
        };
        dispatchGetMasterDataUsersDepartmentAction(finalData);
      }
    },
    500,
    [usersDepartmentText]
  );

  const fetchNewData = (search: string) => {
    setSearchClear(true);
    const finacUserData = {
      token,
      offset,
      limit,
      search_term: search,
    };
    dispatchGetAllUserGroupsAction(finacUserData);
  };

  useDebounce(
    () => {
      if (assignGroup) {
        fetchNewData(assignGroup);
      }
    },
    500,
    [assignGroup]
  );

  useEffect(() => {
    if (searchClear) {
      const finacUserData = {
        token,
        offset,
        limit,
        search_term: assignGroup,
      };
      if (assignGroup?.length === 0) {
        dispatchResetUserGroupList();
        dispatchGetAllUserGroupsAction(finacUserData);
        setOffset(0);
      }
    }
  }, [assignGroup, searchClear]);

  useEffect(() => {
    if (userGroupList?.length > 0) {
      if (offset <= +userGroupCount) {
        let finalFilterGroupData = userGroupList?.filter((group: any) => {
          if (group?.group_id !== 3) {
            return group;
          }
        });

        let finalGroupData = finalFilterGroupData?.map((group: any) => {
          return {
            value: group.group_id,
            label: group.group_name,
          };
        });

        if (offset > 0) {
          setFinalUserGroupList([...finalUserGroupList, ...finalGroupData]);
        } else {
          setFinalUserGroupList([...finalGroupData]);
        }
      }
    }
  }, [userGroupList]);

  // // country dropdown things

  useEffect(() => {
    const finalCountryData = countryList?.map((data: any) => {
      return {
        value: data?.id,
        label: data?.name,
      };
    });
    if (countryoffset > 0) {
      setCountrySelectedList([...countrySelectedList, ...finalCountryData]);
    } else {
      setCountrySelectedList(finalCountryData);
    }
  }, [countryList]);

  useEffect(() => {
    dispatchResetCityList();
    dispatchResetStateList();
    if (token) {
      let finalCountryData = {
        token,
        offset: countryoffset,
        limit: countrylimit,
        search_term: countrytext,
      };
      if (countryoffset <= countryListTotalCount) {
        dispatchGetCountryListAction(finalCountryData);
      }
    }
  }, [countryoffset]);

  const fetchNewCountryData = (search: string) => {
    const finalData = {
      token,
      offset: countryoffset,
      limit: countrylimit,
      search_term: countrytext,
    };
    dispatchGetCountryListAction(finalData);
  };

  useDebounce(
    () => {
      if (countrytext) {
        fetchNewCountryData(countrytext);
      } else {
        const finalData = {
          token,
          offset: countryoffset,
          limit: countrylimit,
          search_term: countrytext,
        };
        dispatchGetCountryListAction(finalData);
      }
    },
    500,
    [countrytext]
  );

  const handleChangeCountry = (data: any) => {
    setCountry({
      value: data?.value,
      label: data?.label,
    });
    if (data?.value && profileDetailsError?.countryError) {
      setProfileDetailsError((prev: any) => {
        return {
          ...prev,
          countryError: "",
        };
      });
    }
    setProfileDetailsError((prev: any) => {
      return {
        ...prev,
        stateError: "",
      };
    });
  };

  const onMenuClose = () => {
    setLoadCondition(true);
  };
  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <CircularAvatar
            name={data?.label.split("%")[0]}
            image={data?.image && data?.image}
          />
          <div style={{ marginTop: "-3px" }}>
            <span style={{ fontWeight: "500", fontSize: "16px" }}>
              {data?.label.split("%")[0]}
            </span>
            <br></br>
            <span style={{ color: "#6e7491" }}>
              {data?.label.split("%")[1]}
            </span>
          </div>
        </div>
      </components.Option>
    );
  };

  // state
  useEffect(() => {
    dispatchResetCityList();
    if (profileForm?.user_details?.current_address?.country?.value) {
      let finalData: GetStateListDataPayloadType = {
        token,
        limit,
        offset: stateOffset,
        search_term: stateText,
        country_id: profileForm?.user_details?.current_address?.country?.value,
      };

      if (stateOffset === 0) {
        dispatchGetAllStateAction(finalData);

        setIsApiCall(true);
      } else {
        dispatchGetAllStateAction(finalData);
        setStateOffset(0);
        setIsApiCall(true);
      }
    }
  }, [profileForm?.user_details?.current_address?.country?.value]);
  //

  useEffect(() => {
    dispatchResetCityList();
    if (
      isState === false &&
      !stateFetching &&
      profileForm?.user_details?.current_address?.country?.value
    ) {
      let finalData: GetCityListDataPayloadType = {
        token,
        limit,
        offset: cityOffset,
        search_term: cityText,
        country_id: profileForm?.user_details?.current_address?.country?.value,
      };
      if (cityOffset === 0) {
        dispatchGetAllCityAction(finalData);
      } else {
        setCityOffset(0);
      }
    }
  }, [isState]);

  useEffect(() => {
    const finalStateData = stateList?.map((data: any) => {
      return {
        value: data?.id,
        label: data?.name,
      };
    });
    if (stateOffset > 0) {
      setFinalStateList([...finalStateList, ...finalStateData]);
    } else {
      setFinalStateList(finalStateData);
    }
  }, [stateList]);

  useEffect(() => {
    dispatchResetCityList();
    if (token && stateOffset != 0) {
      let finalStateData = {
        token,
        offset: stateOffset,
        limit,
        search_term: stateText,
        country_id: profileForm?.user_details?.current_address?.country?.value,
      };
      if (stateOffset <= stateListTotalCount) {
        dispatchGetAllStateAction(finalStateData);
      }
    }
  }, [stateOffset]);

  const fetchData = (search: string) => {
    const finalData = {
      token,
      offset: stateOffset,
      limit,
      search_term: stateText,
      country_id: profileForm?.user_details?.current_address?.country?.value,
    };

    dispatchGetAllStateAction(finalData);
  };

  useDebounce(
    () => {
      if (stateText && isApiCall) {
        fetchData(stateText);
      } else if (isApiCall) {
        const finalData = {
          token,
          offset: stateOffset,
          limit,
          search_term: stateText,
          country_id:
            profileForm?.user_details?.current_address?.country?.value,
        };
        dispatchGetAllStateAction(finalData);
      }
    },
    500,
    [stateText]
  );

  // permannent address

  useEffect(() => {
    dispatchResetCityListPermanentAddress();
    if (profileForm?.user_details?.permanent_address?.country?.value) {
      let finalData: GetStateListDataPayloadType = {
        token,
        limit,
        offset: stateAddressOffset,
        search_term: stateAddressText,
        country_id:
          profileForm?.user_details?.permanent_address?.country?.value,
      };

      if (stateAddressOffset === 0) {
        dispatchGetAllStatePermanentAddressAction(finalData);

        setIsApiAddressCall(true);
      } else {
        dispatchGetAllStatePermanentAddressAction(finalData);
        setStateAddressOffset(0);
        setIsApiAddressCall(true);
      }
    }
  }, [profileForm?.user_details?.permanent_address?.country?.value]);
  //

  useEffect(() => {
    dispatchResetCityListPermanentAddress();
    if (
      isStatePermanentAddress === false &&
      !stateFetchingPermanentAddress &&
      profileForm?.user_details?.permanent_address?.country?.value
    ) {
      let finalData: GetCityListDataPayloadType = {
        token,
        limit,
        offset: cityAddressOffset,
        search_term: cityAddressText,
        country_id:
          profileForm?.user_details?.permanent_address?.country?.value,
      };
      if (cityAddressOffset === 0) {
        dispatchGetAllCityPermanentAddressAction(finalData);
      } else {
        setCityAddressOffset(0);
      }
    }
  }, [isStatePermanentAddress]);

  useEffect(() => {
    const finalStateData = stateListPermanentAddress?.map((data: any) => {
      return {
        value: data?.id,
        label: data?.name,
      };
    });
    if (stateAddressOffset > 0) {
      setFinalStateAddressList([...finalStateAddressList, ...finalStateData]);
    } else {
      setFinalStateAddressList(finalStateData);
    }
  }, [stateListPermanentAddress]);

  useEffect(() => {
    dispatchResetCityListPermanentAddress();
    if (token && stateAddressOffset != 0) {
      let finalStateData = {
        token,
        offset: stateAddressOffset,
        search_term: stateAddressText,
        limit,
        country_id:
          profileForm?.user_details?.permanent_address?.country?.value,
      };
      if (stateAddressOffset <= stateListTotalCountPermanentAddress) {
        dispatchGetAllStatePermanentAddressAction(finalStateData);
      }
    }
  }, [stateAddressOffset]);

  const fetchPermanentAddressData = (search: string) => {
    const finalData = {
      token,
      offset: stateAddressOffset,
      search_term: stateAddressText,
      limit,
      country_id: profileForm?.user_details?.permanent_address?.country?.value,
    };

    dispatchGetAllStatePermanentAddressAction(finalData);
  };

  useDebounce(
    () => {
      if (stateAddressText && isApiAddressCall) {
        fetchPermanentAddressData(stateAddressText);
      } else if (isApiAddressCall) {
        const finalData = {
          token,
          offset: stateAddressOffset,
          limit,
          search_term: stateAddressText,
          country_id:
            profileForm?.user_details?.permanent_address?.country?.value,
        };
        dispatchGetAllStatePermanentAddressAction(finalData);
      }
    },
    500,
    [stateAddressText]
  );

  //

  const handleChangeState = (data: any) => {
    setAddressState({
      value: data?.value,
      label: data?.label,
    });

    if (data?.value && profileDetailsError.stateError) {
      setProfileDetailsError((prevState: any) => ({
        ...prevState,
        stateError: "",
      }));
    }
    setProfileDetailsError((prevState: any) => ({
      ...prevState,
      cityError: "",
    }));
  };

  // city
  useEffect(() => {
    let finalData: GetCityListDataPayloadType = {
      token,
      limit,
      offset: cityOffset,
      search_term: cityText,
      state_id: profileForm?.user_details?.current_address?.state?.value,
    };
    if (profileForm?.user_details?.current_address?.state?.value) {
      if (cityOffset === 0) {
        dispatchGetAllCityAction(finalData);

        setIsApiCityCall(true);
      } else {
        dispatchGetAllCityAction(finalData);
        setCityOffset(0);
        setIsApiCityCall(true);
      }
    }
  }, [profileForm?.user_details?.current_address?.state?.value]);

  //

  useEffect(() => {
    const finalCityData = cityList?.map((data: any) => {
      return {
        value: data?.id,
        label: data?.name,
      };
    });
    if (cityOffset > 0) {
      setFinalCityList([...finalCityList, ...finalCityData]);
    } else {
      setFinalCityList(finalCityData);
    }
  }, [cityList]);

  useEffect(() => {
    if (finacAssetListing?.length) {
      let finalFinacAssetListing = finacAssetListing?.map((list: any) => {
        return {
          value: list?.id,
          label: list?.asset_description,
        };
      });
      if (finacAssetOffset > 0) {
        setFinalFinacAssetList([
          ...finalFinacAssetList,
          ...finalFinacAssetListing,
        ]);
      } else {
        setFinalFinacAssetList([...finalFinacAssetListing]);
      }
    }
  }, [finacAssetListing]);

  useEffect(() => {
    if (token && cityOffset !== 0) {
      let finalcityData = {
        token,
        offset: cityOffset,
        limit,
        search_term: cityText,
        state_id: profileForm?.user_details?.current_address?.state?.value,
      };
      if (cityOffset <= cityListTotalCount) {
        dispatchGetAllCityAction(finalcityData);
      }
    }
  }, [cityOffset]);

  const fetchCityData = (search: string) => {
    const finalData = {
      token,
      offset: cityOffset,
      limit,
      search_term: cityText,
      state_id: profileForm?.user_details?.current_address?.state?.value,
    };
    dispatchGetAllCityAction(finalData);
  };

  useDebounce(
    () => {
      if (cityText && isApiCityCall) {
        fetchCityData(cityText);
      } else if (isApiCityCall) {
        const finalData = {
          token,
          offset: cityOffset,
          limit,
          search_term: cityText,
          state_id: profileForm?.user_details?.current_address?.state?.value,
        };
        dispatchGetAllCityAction(finalData);
      }
    },
    500,
    [cityText]
  );
  // city permanent address

  useEffect(() => {
    let finalData: GetCityListDataPayloadType = {
      token,
      limit,
      offset: cityAddressOffset,
      search_term: cityAddressText,
      state_id: profileForm?.user_details?.permanent_address?.state?.value,
    };
    if (profileForm?.user_details?.permanent_address?.state?.value) {
      if (cityAddressOffset === 0) {
        dispatchGetAllCityPermanentAddressAction(finalData);

        setIsApiCityAddressCall(true);
      } else {
        dispatchGetAllCityPermanentAddressAction(finalData);
        setCityAddressOffset(0);
        setIsApiCityAddressCall(true);
      }
    }
  }, [profileForm?.user_details?.permanent_address?.state?.value]);

  //

  useEffect(() => {
    const finalCityData = cityListPermanentAddress?.map((data: any) => {
      return {
        value: data?.id,
        label: data?.name,
      };
    });
    if (cityAddressOffset > 0) {
      setFinalCityAddressList([...finalCityAddressList, ...finalCityData]);
    } else {
      setFinalCityAddressList(finalCityData);
    }
  }, [cityListPermanentAddress]);

  useEffect(() => {
    if (token && cityAddressOffset !== 0) {
      let finalcityData = {
        token,
        limit,
        offset: cityAddressOffset,
        search_term: cityAddressText,
        state_id: profileForm?.user_details?.permanent_address?.state?.value,
      };
      if (cityAddressOffset <= cityListTotalCountPermanentAddress) {
        dispatchGetAllCityPermanentAddressAction(finalcityData);
      }
    }
  }, [cityAddressOffset]);

  const fetchCityAddressData = (search: string) => {
    const finalData = {
      token,
      limit,
      offset: cityAddressOffset,
      search_term: cityAddressText,
      state_id: profileForm?.user_details?.permanent_address?.state?.value,
    };
    dispatchGetAllCityPermanentAddressAction(finalData);
  };

  useDebounce(
    () => {
      if (cityAddressText && isApiCityAddressCall) {
        fetchCityAddressData(cityAddressText);
      } else if (isApiCityAddressCall) {
        const finalData = {
          token,
          offset: cityAddressOffset,
          limit,
          search_term: cityAddressText,
          state_id: profileForm?.user_details?.permanent_address?.state?.value,
        };
        dispatchGetAllCityPermanentAddressAction(finalData);
      }
    },
    500,
    [cityAddressText]
  );

  useEffect(() => {
    const skillsData = skillMasterDataList?.map((data: any) => {
      return {
        value: data?._id,
        label: data?.skill_name,
      };
    });
    if (skillsOffset > 0) {
      setFinalSkillList([...finalSkillList, ...skillsData]);
    } else {
      setFinalSkillList(skillsData);
    }
  }, [skillMasterDataList]);
  useEffect(() => {
    if (token) {
      let finalData = {
        token,
        searchValue: skillsText,
        limit,
        offset: skillsOffset,
        status: 1
      };
      if (skillsOffset <= +skillsMasterDataTotalCount) {
        dispatchGetMasterDataSkillsModuleAction(finalData);
      }
    }
  }, [skillsOffset]);

  const fetchNewSkillsData = (search: string) => {
    let finalData = {
      token,
      searchValue: skillsText,
      limit,
      offset: skillsOffset,
      status: 1

    };
    dispatchGetMasterDataSkillsModuleAction(finalData);
  };

  useDebounce(
    () => {
      if (skillsText) {
        fetchNewSkillsData(skillsText);
      } else {
        let finalData = {
          token,
          searchValue: skillsText,
          limit,
          offset: skillsOffset,
          status: 1

        };
        dispatchGetMasterDataSkillsModuleAction(finalData);
      }
    },
    500,
    [skillsText]
  );

  const getPanDetails = (e: any) => {
    e.preventDefault();
    dispatchResetPanVerifyData();
    if (profileForm?.payroll_settings?.identification_details?.pan && token) {
      const finalData = {
        token,
        panNo: profileForm?.payroll_settings?.identification_details?.pan,
      };
      dispatchVerifyPanAction(finalData);
    }
  };

  const getBankDetails = ({ e, ifscCode, accountNumber }: any) => {
    e.preventDefault();
    dispatchResetServicesError();
    dispatchResetBankAccountDetails();
    if (ifscCode && accountNumber && token) {
      const finalData = {
        token,
        ifsc_no: ifscCode,
        account_number: accountNumber,
      };
      dispatchGetBankAccountInfoAction?.(finalData);
    }
  };

  const resetBankDetailsData = () => {
    dispatchResetServicesError();
    dispatchResetBankAccountDetails();
  };

  const handleChangeCity = (data: any) => {
    setSelectedCityList({
      value: data?.value,
      label: data?.label,
    });
    if (data?.value && profileDetailsError?.cityError) {
      setProfileDetailsError((prevState: any) => ({
        ...prevState,
        cityError: "",
      }));
    }
  };

  const handleTabChange = (tabs: string) => {
    setActiveTab(tabs);
  };

  const handleChangeClient = (client: any) => {
    setClientSelected(client);
  };
  const checkClientBottom = () => {
    setClientOffset((prv: any) => prv + clientLimit);
  };
  const renderTabs = () => {
    let finalTab = tabs?.map((tab: TabsType) => {
      return (
        <div
          className="tab-style mr-4 "
          key={tab.label}
          onClick={() => {
            handleTabChange(tab.label);
          }}
        >
          <div
            style={{
              padding: "12px 5px 12px 5px",
              color: activeTab === tab.label ? "#dd4433" : "",
              fontSize: "14px",
            }}
            className={`tab-header ${activeTab === tab.label ? "active" : ""}`}
          >
            {tab.name}
          </div>
          <div
            className={`${activeTab === tab.label
              ? "active-tab-bottom-border"
              : "not-active-tab-bottom-border"
              }`}
          ></div>
        </div>
      );
    });

    return finalTab;
  };
  useDebounce(
    () => {
      // const emailValidation=!isEmailValid(uniqueEmail?.email?uniqueEmail?.email:"")
      const emailValidation = !isEmailValid(
        profileForm?.user_details?.basic_details?.email_id
      );
      if (
        emailValidation &&
        profileForm?.user_details?.basic_details?.email_id?.length
      ) {
        setProfileDetailsError((prv) => ({
          ...prv,
          emailError: "Email not valid",
        }));
      } else {
        setProfileDetailsError((prv) => ({
          ...prv,
          emailError: "",
        }));
      }

      if (profileForm.user_details.basic_details.email_id) {
        dispatchCheckUniqueEmailAction(uniqueEmail);
      }
    },
    500,
    [uniqueEmail]
  );
  useDebounce(
    () => {
      if (profileForm.user_details.contact_details.mobile) {
        dispatchCheckUniqueMobileNoAction(uniqueMobileNo);
      }
    },
    500,
    [uniqueMobileNo]
  );

  useDebounce(
    () => {
      if (profileForm?.payroll_settings?.identification_details?.adhar_number) {
        dispatchCheckUniqueAadhaarAction(uniqueAadhaarNo);
      }
    },
    500,
    [uniqueAadhaarNo]
  );

  useDebounce(
    () => {
      if (
        profileForm?.payroll_settings?.identification_details?.passport_number
      ) {
        dispatchCheckUniquePassportAction(uniquePassportNo);
      }
    },
    500,
    [uniquePassportNo]
  );

  useDebounce(
    () => {
      if (profileForm?.payroll_settings?.identification_details?.uan_number) {
        dispatchCheckUniqueUanAction(uniqueUanNo);
      }
    },
    500,
    [uniqueUanNo]
  );

  useDebounce(
    () => {
      if (profileForm?.payroll_settings?.identification_details?.pan) {
        dispatchCheckUniquePanAction(uniquePanNo);
      }
    },
    500,
    [uniquePanNo]
  );
  function handleUserDeatilsForm(e: any) {
    if (e.target.name === "first_name") {
      setProfileDetailsError((prevState) => ({
        ...prevState,
        nameError: "",
      }));
    }

    if (e.target.name === "email_id") {
      if (token) {
        const finalData = {
          token,
          operation: "add",
          email: e.target.value,
        };
        setUniqueEmail(finalData);
        dispatchResetEmailError();
        dispatchResetEmailMessage();
        dispatchResetEmailFetching();
        dispatchResetIsEmail();
      }
      setProfileDetailsError((prevState) => ({
        ...prevState,
        emailError: "",
      }));
    }

    setProfileForm((prv: UserProfileType) => {
      return {
        ...prv,
        user_details: {
          ...prv.user_details,
          basic_details: {
            ...prv.user_details.basic_details,
            [e.target.name]: e.target.value,
          },
        },
      };
    });
  }
  const handleSkillChange = (e: any) => {
    setProfileForm((prv: any) => {
      return {
        ...prv,
        user_details: {
          ...prv.user_details,
          basic_details: {
            ...prv.user_details.basic_details,
            skill: e,
          },
        },
      };
    });
  }
  const checkUsersDepartmentBottom = () => {
    setUsersDepartmentOffset((prv: any) => prv + clientLimit);
  };

  /// handle Access Details component
  function handleAccessDeatilsForm(e: any) {
    if (e.target.name === "newPassword") {
      setProfileDetailsError((prevState) => ({
        ...prevState,
        newPasswordError: "",
      }));
    }
    if (e.target.name === "password") {
      setProfileDetailsError((prevState) => ({
        ...prevState,
        newPasswordAgainError: "",
      }));
    }
    if (e.target.name === "newPassword") {
    } else {
      setProfileForm((prv: UserProfileType) => {
        return {
          ...prv,
          user_details: {
            ...prv.user_details,
            basic_details: {
              ...prv.user_details.basic_details,
              access_details: {
                ...prv.user_details.basic_details.access_details,
                [e.target.name]: e.target.value,
              },
            },
          },
        };
      });
    }
  }

  const finacAssetApiCall = (index: number) => {
    setFinacAssetOffset(0);
    setActiveTabIndex(index);
    setFinalFinacAssetList([]);
    dispatchResetFixedAssetRegisterListing();
    dispatchResetFixedAssetRegisterTotalCount();
    if (accordianJobDetailsData[index]?.job_info?.client) {
      let finalData = {
        token,
        client_code: accordianJobDetailsData[index]?.job_info?.client,
        limit: assetLimit,
        offset: 0,
        is_assigned: 0,
      };
      dispatchGetFixedAssetRegisterListing(finalData);
    }
  };

  // handle work component form
  function handleWorkDeatilsForm(e: any) {
    setProfileForm((prv: UserProfileType) => {
      return {
        ...prv,
        hr_settings: {
          ...prv.hr_settings,
          work_details: {
            ...prv.hr_settings?.work_details,
            [e.target.name]: e.target.value,
          },
        },
      };
    });
  }

  // handle job component form
  function handleJobDeatilsForm(e: any) {
    setProfileForm((prv: UserProfileType) => {
      return {
        ...prv,
        job_details: {
          ...prv.job_details,
          job_info: {
            ...prv.job_details.job_info,
            [e.target.name]: e.target.value,
          },
        },
      };
    });
  }

  //handle personal Details
  function handlePersonalDetails(e: any) {
    setProfileForm((prv: UserProfileType) => {
      return {
        ...prv,
        user_details: {
          ...prv.user_details,
          personal_details: {
            ...prv.user_details.personal_details,
            [e.target.name]: e.target.value,
          },
        },
      };
    });
  }

  //handl Address Details

  const handleAddressDetails = (e: any) => {
    setProfileForm((prv: UserProfileType) => {
      return {
        ...prv,
        user_details: {
          ...prv.user_details,
          current_address: {
            ...prv.user_details.current_address,
            [e.target.name]: e.target.value,
          },
        },
      };
    });
  };

  //handl PermanetAddress Details

  const handlePermanetAddressDetails = (e: any) => {
    setProfileForm((prv: UserProfileType) => {
      return {
        ...prv,
        user_details: {
          ...prv.user_details,
          permanent_address: {
            ...prv.user_details.permanent_address,
            [e.target.name]: e.target.value,
          },
        },
      };
    });
  };

  // handle communications
  const handleCommunicationsDetails = (e: any) => {
    if (e.target.name === "mobile" && e.target.value.length) {
      const finalData = {
        token,
        operation: "add",
        mobile: e.target.value?.trim(),
        email: null,
      };
      setUniqueMobileNo(finalData);
      dispatchResetMobileError();
      dispatchResetMobileMessage();
      dispatchResetMobileFetching();
      dispatchResetIsMobileNo();
    }
    setProfileForm((prv: UserProfileType) => {
      return {
        ...prv,
        user_details: {
          ...prv.user_details,
          contact_details: {
            ...prv.user_details.contact_details,
            [e.target.name]: e.target.value,
          },
        },
      };
    });
  };

  const onlinePresenc = (e: any) => {
    setProfileForm((prv: UserProfileType) => {
      return {
        ...prv,
        user_details: {
          ...prv.user_details,
          online_presence: {
            ...prv.user_details.online_presence,
            [e.target.name]: e.target.value,
          },
        },
      };
    });
  };
  //handle bank id
  const handleBankWorkForm = (e: any) => {
    if (e?.target?.name === "adhar_number" && e?.target?.value?.length) {
      const finalData = {
        token,
        operation: "add",
        aadhaar: e?.target?.value,
        role: "user",
      };
      setUniqueAadhaarNo(finalData);
      dispatchResetAadhaarMessage();
      dispatchResetAadhaarError();
      dispatchResetStatusCodeAadhaar();

      dispatchResetAaddharSuccess();
      setProfileForm((prv: UserProfileType) => {
        return {
          ...prv,
          payroll_settings: {
            ...prv.payroll_settings,
            identification_details: {
              ...prv.payroll_settings.identification_details,
              [e.target.name]: e.target.value,
            },
          },
        };
      });
    } else if (e?.target?.name === "pan" && e?.target?.value?.length) {
      dispatchResetPanVerifyData();
      const finalData = {
        token,
        operation: "add",
        pan: e?.target?.value.toUpperCase(),
        role: "user",
      };

      setUniquePanNo(finalData);
      dispatchResetPanMessage();
      dispatchResetPanError();
      dispatchResetStatusCodePan();
      dispatchResetPanSuccess();
      setProfileForm((prv: UserProfileType) => {
        return {
          ...prv,
          payroll_settings: {
            ...prv.payroll_settings,
            identification_details: {
              ...prv.payroll_settings.identification_details,
              pan: e.target.value.toUpperCase(),
            },
          },
        };
      });
    } else if (
      e?.target?.name === "passport_number" &&
      e?.target?.value?.length
    ) {
      const finalData = {
        token,
        operation: "add",
        passport: e?.target?.value,
        role: "user",
      };
      setUniquePassportNo(finalData);
      dispatchResetPassportMessage();
      dispatchResetPassportError();
      dispatchResetStatusCodePassport();
      dispatchResetPassportSuccess();
      setProfileForm((prv: UserProfileType) => {
        return {
          ...prv,
          payroll_settings: {
            ...prv.payroll_settings,
            identification_details: {
              ...prv.payroll_settings.identification_details,
              [e.target.name]: e.target.value,
            },
          },
        };
      });
    } else if (e?.target?.name === "uan_number" && e?.target?.value?.length) {
      const finalData = {
        token,
        operation: "add",
        uan_no: e.target.value,
        role: "user",
      };
      setUniqueUanNo(finalData);
      dispatchResetUanMessage();
      dispatchResetUanError();
      dispatchResetStatusCodeUan();
      dispatchResetUanSuccess();
      setProfileForm((prv: UserProfileType) => {
        return {
          ...prv,
          payroll_settings: {
            ...prv.payroll_settings,
            identification_details: {
              ...prv.payroll_settings.identification_details,
              [e.target.name]: e.target.value,
            },
          },
        };
      });
    } else {
      setProfileForm((prv: UserProfileType) => {
        return {
          ...prv,
          payroll_settings: {
            ...prv.payroll_settings,
            identification_details: {
              ...prv.payroll_settings.identification_details,
              [e.target.name]: e.target.value,
            },
          },
        };
      });
    }
  };

  //handle bank id
  const handleBankAccountWorkForm = (e: any) => {
    setProfileForm((prv: UserProfileType) => {
      return {
        ...prv,
        payroll_settings: {
          ...prv.payroll_settings,
          identification_details: {
            ...prv.payroll_settings.identification_details,
            [e.target.name]: e.target.value,
          },
        },
      };
    });
  };
  const handleToggleIsAccess = () => {
    setAccess(!access);
  };
  const handleSubmit = async () => {
    let tempData = JSON.parse(JSON.stringify(accordianJobDetailsData));
    tempData?.forEach((item: any) => {
      item.is_default = item?.is_default;
      item.job_info.employee_id = item?.job_info?.employee_id;
      item.job_info.job_title = item?.job_info?.job_title?.trim();
      item.job_info.department = item.job_info.department = {
        id: item?.job_info?.department?.value,
        name: item?.job_info?.department?.value
          ? item?.job_info?.department?.label
          : "",
      };
      item.job_info.start_date = item?.job_info?.start_date
        ? reverseDate(item?.job_info?.start_date)
        : null;
      item.job_info.probation_end_date =
        profileForm?.hr_settings?.employment_status === "Probation" &&
          item?.job_info?.start_date
          ? reverseDate(item?.job_info?.probation_end_date)
          : null;
      item.job_info.end_date = item?.job_info?.end_date
        ? reverseDate(item?.job_info?.end_date)
        : null;
      item.job_info.total_experience = item?.job_info?.total_experience?.trim();
      item.job_info.rejoin_date = item?.job_info?.rejoin_date
        ? reverseDate(item?.job_info?.rejoin_date)
        : null;
      item.job_info.date_of_notice = item?.job_info?.date_of_notice
        ? reverseDate(item?.job_info?.date_of_notice)
        : null;
      item.job_info.date_of_relieve = item?.job_info?.date_of_relieve
        ? reverseDate(item?.job_info?.date_of_relieve)
        : null;
      item.job_info.date_of_conformation = item?.job_info?.date_of_conformation
        ? reverseDate(item?.job_info?.date_of_conformation)
        : null;
      item.job_info.client = item?.job_info?.client
        ? item?.job_info?.client
        : null;
      item.reporting_details.it_assets_assigned =
        item?.reporting_details?.it_assets_assigned?.trim();
      item.reporting_details.far_assigned_details =
        item?.reporting_details?.far_assigned_details?.map((item: any) => ({
          far_it_assets_assigned: {
            far_id: item?.far_it_assets_assigned?.value,
            asset_description: item?.far_it_assets_assigned?.label,
          },
          far_start_date: item?.far_start_date
            ? reverseDate(item?.far_start_date)
            : null,
          far_end_date: item?.far_end_date
            ? reverseDate(item?.far_end_date)
            : null,
        }));
      item.reporting_details.reporting_person = item?.reporting_details
        ?.reporting_person
        ? item?.reporting_details?.reporting_person
        : null;
      item.reporting_details.coach = item?.reporting_details?.coach
        ? item?.reporting_details?.coach
        : null;
      item.reporting_details.show_coach = null;
      item.file_attachment = item?.file_attachment;
      item.emailer_settings = item?.emailer_settings?.length
        ? item.emailer_settings
        : [];
      delete item.isOpen;
      delete item.isDeleteIcon;
      delete item.job_info.show_client;
      delete item.reporting_details.show_reporting_person;
      delete item.show_emailer_settings;
      delete item.reporting_details.show_coach;
    });
    let enCurrentPassword;
    if (profileForm?.user_details?.basic_details?.access_details?.password) {
      enCurrentPassword = await convertPasswordToHash(
        profileForm?.user_details?.basic_details?.access_details?.password
      );
    }
    if (
      profileForm.user_details.basic_details.first_name?.trim() &&
      profileForm.user_details.basic_details.email_id?.trim() &&
      isEmailValid(profileForm.user_details.basic_details.email_id) &&
      ((isState &&
        profileForm?.user_details?.current_address?.state &&
        profileForm?.user_details?.current_address?.country?.value &&
        profileForm?.user_details?.current_address?.city?.value) ||
        (!isState &&
          profileForm?.user_details?.current_address?.country?.value) ||
        (isState &&
          profileForm?.user_details?.current_address.state?.value &&
          profileForm?.user_details?.current_address?.country?.value &&
          !isCity)) &&
      profileForm?.user_details?.basic_details?.access_details?.password?.trim() &&
      newPassword.trim() &&
      profileForm?.user_details?.basic_details?.access_details?.password.trim() &&
      newPassword ===
      profileForm?.user_details?.basic_details?.access_details?.password &&
      !Object.values(passwordResult).includes(false) &&
      !mobileMessage?.includes("mobile") &&
      !emailMessage?.includes("email") &&
      !aadhaarMessage?.includes("already exists") &&
      !panMessage?.includes("already exists")
    ) {
      if (token) {
        let dateOfBirth = profileForm?.user_details?.personal_details
          ?.date_of_birth
          ? profileForm?.user_details?.personal_details?.date_of_birth
          : null;
        let passportExpiry = profileForm?.payroll_settings
          ?.identification_details?.passport_expiry
          ? profileForm?.payroll_settings?.identification_details
            ?.passport_expiry
          : null;
        let userBranch = profileForm?.hr_settings?.work_details?.user_branch
          ? profileForm?.hr_settings?.work_details?.user_branch
          : profileForm?.hr_settings?.work_details?.user_branch
            ? profileForm?.hr_settings?.work_details?.user_branch
            : null;
        if (userBranch) {
          userBranch = {
            branch_id: userBranch.value,
            branch_name: userBranch.label,
          };
        }

        let skillsID = profileForm?.user_details?.basic_details?.skill?.map((id: any) => id.value)
        let newData = {
          ...profileForm,
          user_details: {
            ...profileForm.user_details,
            //
            current_address: {
              ...profileForm?.user_details?.current_address,
              city: profileForm?.user_details?.current_address?.city?.label,
              state: profileForm?.user_details?.current_address?.state?.label,
              country:
                profileForm?.user_details?.current_address?.country?.label,
            },
            //
            //
            permanent_address: {
              ...profileForm?.user_details?.permanent_address,
              city: profileForm?.user_details?.permanent_address?.city?.label,
              state: profileForm?.user_details?.permanent_address?.state?.label,
              country:
                profileForm?.user_details?.permanent_address?.country?.label,
            },
            //
            basic_details: {
              ...profileForm.user_details.basic_details,
              first_name:
                profileForm.user_details.basic_details.first_name?.trim(),
              last_name:
                profileForm.user_details.basic_details.last_name?.trim(),
              access_details: {
                ...profileForm.user_details.basic_details.access_details,
                status: access ? true : false,
                password: enCurrentPassword,
              },
              skill: skillsID,

            },
            personal_details: {
              ...profileForm.user_details.personal_details,
              date_of_birth: dateOfBirth ? formatDate(dateOfBirth) : null,
            },
          },
          hr_settings: {
            ...profileForm.hr_settings,
            is_govt_officer: profileForm?.hr_settings?.is_govt_officer ? 1 : 0,
            work_details: {
              ...profileForm.hr_settings.work_details,
              user_branch: userBranch,
            },
          },
          job_details: [...tempData],
          payroll_settings: {
            ...profileForm.payroll_settings,
            identification_details: {
              ...profileForm.payroll_settings.identification_details,
              passport_expiry: passportExpiry
                ? formatDate(passportExpiry)
                : null,
            },
          },
          user_settings: {
            ...profileForm.user_settings,
          },
        };
        dispatchResetAuthSuccess();
        dispatchResetUserManagementSuccess();
        let finalData = { profileData: { ...newData }, token };
        dispatchAddUser(finalData);
      }
    } else {
      if (
        !isEmailValid(profileForm?.user_details?.basic_details?.email_id) &&
        profileForm?.user_details?.basic_details?.email_id?.trim().length
      ) {
        setProfileDetailsError((prv) => ({
          ...prv,
          emailError: "Email not valid",
        }));
      }
      if (
        newPassword?.length > 0 &&
        Object.values(passwordResult).includes(false)
      ) {
        setProfileDetailsError((prv) => ({
          ...prv,
          newPasswordError: "Password must meet requirements",
          newPasswordAgainError: "",
        }));
      } else if (
        newPassword.length > 0 &&
        newPassword !==
        profileForm?.user_details?.basic_details?.access_details?.password
      ) {
        setProfileDetailsError((prv) => ({
          ...prv,
          newPasswordAgainError: "Password not same",
        }));
      }

      validation();
      setProfileDetailsError((prv) => ({
        ...prv,
        ...(!profileForm.user_details.basic_details.first_name?.trim() && {
          nameError: "First Name required",
        }),
        ...(!profileForm.user_details.basic_details.email_id?.trim() && {
          emailError: "Email required",
        }),
        ...(!newPassword.trim() && {
          newPasswordError: "Password required",
        }),
        ...(!profileForm.user_details?.current_address?.country?.value && {
          countryError: "Country required",
        }),
        ...(!profileForm.user_details?.current_address?.state?.value && {
          stateError: "State required",
        }),
        ...(!profileForm.user_details?.current_address?.city?.value && {
          cityError: "City required",
        }),
        ...(!profileForm?.user_details?.basic_details?.access_details?.password?.trim() && {
          newPasswordAgainError: "Password required",
        }),
      }));
    }
  };

  function validation() {
    if (
      !profileForm.user_details.basic_details.first_name?.trim() ||
      !profileForm.user_details.basic_details.email_id?.trim() ||
      !profileForm?.user_details?.basic_details?.access_details?.password?.trim() ||
      !newPassword.trim()
    ) {
      return toast.error("Please fill all the mandatory values", {
        duration: 3500,
      });
    } else if (
      newPassword.length > 0 &&
      newPassword !==
      profileForm?.user_details?.basic_details?.access_details?.password
    ) {
      return toast.error("Password not same", {
        duration: 3500,
      });
    } else if (
      !isEmailValid(profileForm?.user_details?.basic_details?.email_id) &&
      profileForm?.user_details?.basic_details?.email_id?.trim().length
    ) {
      return toast.error("Email not valid", {
        duration: 3500,
      });
    }
  }

  const handleAddAnotherJobDetails = () => {
    let temp: any = JSON.parse(JSON.stringify(accordianJobDetailsData));
    temp.push(...JSON.parse(JSON.stringify(accordianJobDetails)));
    setAccordianJobDetailsData(temp);
  };

  const handleRemoveJobDetailsRow = (index: number) => {
    let temp = JSON.parse(JSON.stringify(accordianJobDetailsData));
    temp.splice(index, 1);
    let isDefaultPresent = temp?.filter((el: any) => el?.is_default === true);
    if (isDefaultPresent?.length === 0) {
      temp?.forEach((el: any, index: number) => {
        if (index === 0) {
          el.is_default = true;
        }
      });
    }
    setAccordianJobDetailsData(temp);
  };

  const handleErrorModal = () => {
    if (
      success === 0 ||
      successUserManagement === 0 ||
      panSuccess === 0 ||
      aadhaarSuccess === 0
    ) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (successUserManagement === 0) {
        if (statusCodeUserManagement === 401) {
          return (
            <ErrorSuccessModal
              type="error"
              isOpen={!!errorUserManagement}
              title="Error"
              message="Session Expired. Please Login Again!"
              buttonText="Logout"
              onPress={() => dispatchResetSession()}
              statusCode={statusCodeUserManagement}
            />
          );
        }
      } else if (aadhaarSuccess === 0) {
        if (statusCodeAadhaar === 401) {
          return (
            <ErrorSuccessModal
              type="error"
              isOpen={!!aadhaarError}
              title="Error"
              message="Session Expired. Please Login Again!"
              buttonText="Logout"
              onPress={() => dispatchResetSession()}
              statusCode={statusCodeAadhaar}
            />
          );
        }
      } else if (panSuccess === 0) {
        if (statusCodePan === 401) {
          return (
            <ErrorSuccessModal
              type="error"
              isOpen={!!panError}
              title="Error"
              message="Session Expired. Please Login Again!"
              buttonText="Logout"
              onPress={() => dispatchResetSession()}
              statusCode={statusCodePan}
            />
          );
        }
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetAuthError();
              dispatchResetUsersProfileError();
            }}
          />
        );
      }
    } else if (
      success === 1 &&
      message?.includes("Finac user profile updated successfully!")
    ) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={true}
          title="Success"
          message={"Update Successfully"}
          buttonText="OK"
          onPress={() => {
            dispatchResetAuthError();
            history.goBack();
          }}
        />
      );
    } else if (
      success === 1 &&
      message?.includes("Finac user profile added successfully!")
    ) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={true}
          title="Success"
          message={"Profile Added Successfully"}
          buttonText="OK"
          onPress={() => {
            dispatchResetAuthError();
            // history.goBack();
            history.push({
              pathname: "/all-users",
              // state:activeTab
              state: { tabs: activeTabs },
            });

            if (token) {
            }
          }}
        />
      );
    }

    return false;
  };

  let component = (
    <AllUserDetails
      setProfileForm={setProfileForm}
      profileForm={profileForm}
      data={profileForm?.user_details}
      isEdit
      isEmail={isEmail}
      isMobileNo={isMobileNo}
      emailFetching={emailFetching}
      mobileFetching={mobileFetching}
      emailMessage={emailMessage}
      mobileMessage={mobileMessage}
      handleUserDeatilsForm={handleUserDeatilsForm}
      profileDetailsError={profileDetailsError}
      setMobileCountryCode={setMobileCountryCode}
      setWhatsappCountryCode={setWhatsappCountryCode}
      handleAccessDeatilsForm={handleAccessDeatilsForm}
      handlePersonalDetails={handlePersonalDetails}
      handleToggleIsAccess={handleToggleIsAccess}
      handleAddressDetails={handleAddressDetails}
      access={access}
      setNewPassword={setNewPassword}
      newPassword={newPassword}
      finalUserGroupList={finalUserGroupList}
      setAssignGroup={setAssignGroup}
      setOffset={setOffset}
      passwordResult={passwordResult}
      setPasswordResult={setPasswordResult}
      fetchingUser={fetchingUser}
      handlePermanetAddressDetails={handlePermanetAddressDetails}
      handleCommunicationsDetails={handleCommunicationsDetails}
      onlinePresenc={onlinePresenc}
      isNotShow={false}
      sameAddress={sameAddress}
      setSameAddress={setSameAddress}
      onMenuClose={onMenuClose}
      Option={Option}
      countrySelectedList={countrySelectedList}
      countryFetching={countryFetching}
      setLoadCondition={setLoadCondition}
      setCountryText={setCountryText}
      setCountryOffset={setCountryOffset}
      countrylimit={countrylimit}
      handleChangeCountry={handleChangeCountry}
      finalCountry={finalCountry}
      handleChangeState={handleChangeState}
      finalStateList={finalStateList}
      stateFetching={stateFetching}
      setStateText={setStateText}
      setStateOffset={setStateOffset}
      isState={isState}
      isCity={isCity}
      addressState={addressState}
      finalCityList={finalCityList}
      selectedCityList={selectedCityList}
      handleChangeCity={handleChangeCity}
      setCityOffset={setCityOffset}
      setCityText={setCityText}
      finalStateAddressList={finalStateAddressList}
      stateFetchingPermanentAddress={stateFetchingPermanentAddress}
      setStateAddressText={setStateAddressText}
      setStateAddressOffset={setStateAddressOffset}
      isStatePermanentAddress={isStatePermanentAddress}
      finalCityAddressList={finalCityAddressList}
      cityFetchingPermanentAddress={cityFetchingPermanentAddress}
      setCityAddressText={setCityAddressText}
      setCityAddressOffset={setCityAddressOffset}
      isCityPermanentAddress={isCityPermanentAddress}
      skillsText={skillsText}
      finalSkillList={finalSkillList}
      setSkillsOffset={setSkillsOffset}
      setSkillsText={setSkillsText}
      handleSkillChange={handleSkillChange}
      skillFetching={skillFetching}
      limit={limit}
    />
  );

  if (activeTab === "hrsettings") {
    component = (
      <WorkDetails
        data={profileForm?.hr_settings}
        handleWorkDeatilsForm={handleWorkDeatilsForm}
        setProfileForm={setProfileForm}
      />
    );
  }

  if (activeTab === "job") {
    component = (
      <JobDetails
        setClientOffset={setClientOffset}
        setEmailerOffset={setEmailerOffset}
        setfinacUsersOffset={setfinacUsersOffset}
        setAccordianJobDetailsData={setAccordianJobDetailsData}
        accordianJobDetails={accordianJobDetails}
        handleAddAnotherJobDetails={handleAddAnotherJobDetails}
        handleRemoveJobDetailsRow={handleRemoveJobDetailsRow}
        accordianJobDetailsData={accordianJobDetailsData}
        finacUsersList={finalUserList}
        emailList={emailList}
        data={profileForm?.job_details}
        finalClientList={finalClientList}
        clientSelected={clientSelected}
        handleChangeClient={handleChangeClient}
        clientFetching={clientFetching}
        setClientText={setClientText}
        checkClientBottom={checkClientBottom}
        handleJobDeatilsForm={handleJobDeatilsForm}
        setProfileForm={setProfileForm}
        profileForm={profileForm}
        finalFinacAssetList={finalFinacAssetList}
        history={history}
        uploadData={uploadData}
        setUploadData={setUploadData}
        setEmailerText={setEmailerText}
        setText={setText}
        setUsersDepartmentText={setUsersDepartmentText}
        setUsersDepartmentOffset={setUsersDepartmentOffset}
        finalUsersDepartmentList={finalUsersDepartmentList}
        checkUsersDepartmentBottom={checkUsersDepartmentBottom}
        usersDepartmentFetching={usersDepartmentFetching}
        userType={
          pathname.includes("internal-user") ? "internal_user" : "external_user"
        }
        finacAssetApiCall={finacAssetApiCall}
        setFinacAssetText={setFinacAssetText}
        setFinacAssetOffset={setFinacAssetOffset}
        probationField={profileForm?.hr_settings?.employment_status}
        isEdit={false}
      />
    );
  }
  if (activeTab === "bankid") {
    component = (
      <BankIdDetails
        data={profileForm?.payroll_settings}
        handleBankWorkForm={handleBankWorkForm}
        setProfileForm={setProfileForm}
        handleBankAccountWorkForm={handleBankAccountWorkForm}
        aadhaarFetching={aadhaarFetching}
        aadhaarMessage={aadhaarMessage}
        isAadhaarNo={isAadhaarNo}
        panFetching={panFetching}
        panMessage={panMessage}
        isPanNo={isPanNo}
        passportFetching={passportFetching}
        passportMessage={passportMessage}
        isPassportNo={isPassportNo}
        uanFetching={uanFetching}
        uanMessage={uanMessage}
        isUanNo={isUanNo}
        getPanDetails={getPanDetails}
        getBankDetails={getBankDetails}
        bankAccountDetails={bankAccountDetails}
        resetBankDetailsData={resetBankDetailsData}
        servicesFetching={servicesFetching}
        isEdit={false}
        panVerifyDetails={panVerifyDetails}
        servicesError={servicesError}
      />
    );
  }

  if (activeTab === "userSetting") {
    component = (
      <UsersSettings
        userSetting={profileForm?.user_settings}
        setProfileForm={setProfileForm}
      />
    );
  }
  return (
    <>
      <div className="row">
        <div className="col-md-4 mb-3">
          <CommonHeader
            title={`${pathname.includes("internal-user")
              ? "Add Internal User"
              : "Add External User"
              }`}
          />
        </div>
      </div>
      <div className="col-md-12">
        <div
          style={{
            background: "#d8dee4",
            borderRadius: "5px 5px 0 0",
            padding: "0px 15px 0px 15px",
          }}
        >
          <div
            className="d-flex align-items-center"
            style={{ justifyContent: "space-between" }}
          >
            <div className="d-flex">{renderTabs()}</div>
          </div>
        </div>
      </div>
      <div className="col-md-12">
        <div className="card p-3">
          {component}
          <div style={{ marginTop: "2rem" }}>
            <hr></hr>
          </div>

          <div className="row mt-3">
            <div className="col-md-12 d-flex justify-content-end ">
              <button
                className="btn ml-3"
                style={{ border: "1px solid #bfcbe1" }}
                onClick={() => {
                  history.push({
                    pathname: "/all-users",
                    state: { tabs: activeTabs },
                  });
                }}
              >
                Cancel
              </button>
              <button
                disabled={
                  aadhaarMessage?.includes("already exists") ||
                  panMessage?.includes("already exists") ||
                  passportMessage?.includes("already exists") ||
                  uanMessage?.includes("already exists") ||
                  Object.values(passwordResult).includes(false) ||
                  (profileForm?.user_settings?.is_track_aproved_entries &&
                    (!profileForm?.user_settings?.total_target_entries ||
                      profileForm?.user_settings?.total_target_entries == 0))
                }
                className="btn btn-primary ml-3 pr-4 pl-4"
                onClick={handleSubmit}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
      {handleErrorModal()}
      <Toaster />
      {fetching && <Loader />}
    </>
  );
};
const mapStateToProps = (state: RootState) => ({
  fetching: state.usersProfile.fetching,
  token: state.auth.token,
  //   userProfileAllData: state.auth.userProfileAllData,
  fetchingUser: state.userManagement.fetching,
  success: state.usersProfile.success,
  error: state.usersProfile.error,
  errorUserManagement: state.userManagement.error,
  message: state.usersProfile.message,
  statusCode: state.usersProfile.statusCode,
  userGroupList: state.userManagement.userGroupList,
  userGroupCount: state.userManagement.userGroupCount,
  successUserManagement: state.userManagement.success,
  statusCodeUserManagement: state.userManagement.statusCode,
  emailMessage: state.auth.emailMessage,
  emailFetching: state.auth.emailFetching,
  isEmail: state.auth.isEmail,
  mobileMessage: state.auth.mobileMessage,
  mobileFetching: state.auth.mobileFetching,
  isMobileNo: state.auth.isMobileNo,
  aadhaarFetching: state.usersProfile.aadhaarFetching,
  aadhaarSuccess: state.usersProfile.aadhaarSuccess,
  aadhaarMessage: state.usersProfile.aadhaarMessage,
  aadhaarError: state.usersProfile.aadhaarError,
  isAadhaarNo: state.usersProfile.isAadhaarNo,
  panFetching: state.usersProfile.panFetching,
  panSuccess: state.usersProfile.panSuccess,
  panMessage: state.usersProfile.panMessage,
  panError: state.usersProfile.panError,
  isPanNo: state.usersProfile.isPanNo,
  passportFetching: state.usersProfile.passportFetching,
  passportMessage: state.usersProfile.passportMessage,
  isPassportNo: state.usersProfile.isPassportNo,
  uanFetching: state.usersProfile.uanFetching,
  uanMessage: state.usersProfile.uanMessage,
  isUanNo: state.usersProfile.isUanNo,
  statusCodeAadhaar: state.usersProfile.statusCodeAadhaar,
  statusCodePan: state.usersProfile.statusCodePan,
  clientDirectoryList: state.clientDirectory.clientDirectoryList,
  clientFetching: state.clientDirectory.fetching,
  totalCount: state.clientDirectory.totalCount,
  finacUsersList: state.auth.finacUsersList,
  emailerList: state.masterData.emailerList,
  emailListTotalCount: state.masterData.emailListTotalCount,
  countryList: state.masterData.countryList,
  countryListTotalCount: state.masterData.countryListTotalCount,
  countryFetching: state.masterData.countryFetching,
  stateList: state.masterData.stateList,
  stateListTotalCount: state.masterData.stateListTotalCount,
  stateFetching: state.masterData.stateFetching,
  cityList: state.masterData.cityList,
  cityListTotalCount: state.masterData.cityListTotalCount,
  isState: state.masterData.isState,
  isCity: state.masterData.isCity,
  finacAssetListing: state.fixedAssetRegister.finacAssetListing,
  finacAssetTotalCount: state.fixedAssetRegister.totalCount,
  stateListPermanentAddress: state.masterData.stateListPermanentAddress,
  stateListTotalCountPermanentAddress:
    state.masterData.stateListTotalCountPermanentAddress,
  stateFetchingPermanentAddress: state.masterData.stateFetchingPermanentAddress,
  isStatePermanentAddress: state.masterData.isStatePermanentAddress,
  cityListPermanentAddress: state.masterData.cityListPermanentAddress,
  cityListTotalCountPermanentAddress:
    state.masterData.cityListTotalCountPermanentAddress,
  isCityPermanentAddress: state.masterData.isCityPermanentAddress,
  cityFetchingPermanentAddress: state.masterData.cityFetchingPermanentAddress,
  userDepartmentList: state.masterData.userDepartmentList,
  usersDepartmentFetching: state.masterData.fetching,
  panVerifyDetails: state.services.panVerifyDetails,
  bankAccountDetails: state.services.bankAccountDetails,
  servicesFetching: state.services.fetching,
  servicesError: state.services.error,
  skillMasterDataList: state.masterData.skillMasterDataList,
  skillsMasterDataTotalCount: state.masterData.skillsMasterDataTotalCount,
  skillFetching: state.masterData.fetching,

});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetIsEmail: () => dispatch(resetIsEmail()),
  dispatchResetUserGroupList: () => dispatch(resetUserGroupList()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetAuthError: () => dispatch(resetAuthError()),
  dispatchResetUsersProfileError: () => dispatch(resetUsersProfileError()),
  dispatchAddUser: (data: any) => dispatch(addUserPofile(data)),
  dispatchResetAuthSuccess: () => dispatch(resetAuthSuccess()),
  dispatchResetUsersProfileSuccess: () => dispatch(resetUsersProfileSuccess()),
  dispatchGetAllUserGroupsAction: (data: GetAllUserGroupPayloadType) =>
    dispatch(getAllUserGroupsAction(data)),
  dispatchCheckUniqueEmailAction: (
    data: CheckUniquiEmailAndMobilePayloadType
  ) => dispatch(checkUniqueEmailAction(data)),
  dispatchCheckUniqueMobileNoAction: (
    data: CheckUniquiEmailAndMobilePayloadType
  ) => dispatch(checkUniqueMobileNoAction(data)),
  dispatchResetUserManagementError: () => dispatch(resetUserManagementError()),
  dispatchResetUserManagementSuccess: () =>
    dispatch(resetUserManagementSuccess()),
  dispatchResetUserManagementStatusCode: () =>
    dispatch(resetUserManagementStatusCode()),
  dispatchResetEmailError: () => dispatch(resetEmailError()),
  dispatchResetEmailMessage: () => dispatch(resetEmailMessage()),
  dispatchResetEmailFetching: () => dispatch(resetEmailFetching()),
  dispatchResetMobileError: () => dispatch(resetMobileError()),
  dispatchResetMobileMessage: () => dispatch(resetMobileMessage()),
  dispatchResetMobileFetching: () => dispatch(resetMobileFetching()),
  dispatchResetIsMobileNo: () => dispatch(resetIsMobileNo()),
  dispatchResetFixedAssetRegisterTotalCount: () =>
    dispatch(resetFixedAssetRegisterTotalCount()),
  dispatchCheckUniqueAadhaarAction: (data: CheckUniquiAadharPanPayloadType) =>
    dispatch(checkUniqueAadharAction(data)),
  dispatchCheckUniquePanAction: (data: CheckUniquiAadharPanPayloadType) =>
    dispatch(checkUniquePanAction(data)),
  dispatchCheckUniquePassportAction: (data: CheckUniquiAadharPanPayloadType) =>
    dispatch(checkUniquePassportAction(data)),
  dispatchCheckUniqueUanAction: (data: CheckUniquiAadharPanPayloadType) =>
    dispatch(checkUniqueUanAction(data)),
  dispatchResetUanMessage: () => dispatch(resetUanMessage()),
  dispatchResetUanError: () => dispatch(resetUanError()),
  dispatchResetStatusCodeUan: () => dispatch(resetStatusCodeUan()),
  dispatchResetUanSuccess: () => dispatch(resetUanMessage()),
  dispatchResetPanMessage: () => dispatch(resetPanMessage()),
  dispatchResetPanError: () => dispatch(resetPanError()),
  dispatchResetStatusCodePan: () => dispatch(resetStatusCodePan()),
  dispatchResetPanSuccess: () => dispatch(resetPanSuccess()),
  dispatchResetAaddharSuccess: () => dispatch(resetAaddharSuccess()),
  dispatchResetAadhaarMessage: () => dispatch(resetAadhaarMessage()),
  dispatchResetAadhaarError: () => dispatch(resetAadhaarError()),
  dispatchResetStatusCodeAadhaar: () => dispatch(resetStatusCodeAadhaar()),
  dispatchResetPassportMessage: () => dispatch(resetPassportMessage()),
  dispatchResetPassportError: () => dispatch(resetPassportError()),
  dispatchResetStatusCodePassport: () => dispatch(resetStatusCodePassport()),
  dispatchResetPassportSuccess: () => dispatch(resetPassportSuccess()),
  dispatchGetClientDirectoryListAction: (
    data: GetClientDirectoryListPayloadType
  ) => dispatch(getClientDirectoryListAction(data)),
  dispatchGetMasterDataEmailers: (data: GetEmailerDataPayloadType) =>
    dispatch(getMasterDataEmailersAction(data)),
  dispatchResetMasterDataEmailerListing: () => dispatch(resetEmailerList()),
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacUsersAction(data)),
  dispatchGetCountryListAction: (data: GetCountryListDataPayloadType) =>
    dispatch(getAllCountryAction(data)),
  dispatchGetAllStateAction: (data: GetStateListDataPayloadType) =>
    dispatch(getAllStateAction(data)),
  dispatchGetAllStatePermanentAddressAction: (
    data: GetStateListDataPayloadType
  ) => dispatch(getAllStatePermanentAddressAction(data)),
  dispatchGetAllCityAction: (data: GetCityListDataPayloadType) =>
    dispatch(getAllCityAction(data)),
  dispatchResetStateList: () => dispatch(resetStateList()),
  dispatchResetCityList: () => dispatch(resetCityList()),
  dispatchGetAllCityPermanentAddressAction: (
    data: GetCityListDataPayloadType
  ) => dispatch(getAllCityPermanentAddressAction(data)),
  dispatchResetCityListPermanentAddress: () =>
    dispatch(resetCityListPermanentAddress()),
  dispatchGetMasterDataUsersDepartmentAction: (
    data: GetUsersDepartmentPayloadType
  ) => dispatch(getMasterDataUsersDepartmentAction(data)),
  dispatchResetFixedAssetRegisterListing: () =>
    dispatch(resetFixedAssetRegisterListing()),
  dispatchGetFixedAssetRegisterListing: (data: any) =>
    dispatch(getFixedAssetRegisterListing(data)),
  dispatchVerifyPanAction: (data: verifyPanType) =>
    dispatch(verifyPanAction(data)),
  dispatchGetBankAccountInfoAction: (data: getBankAccountNumberType) =>
    dispatch(getBankAccountInfoAction(data)),
  dispatchResetBankAccountDetails: () => dispatch(resetBankAccountDetails()),
  dispatchResetPanVerifyData: () => dispatch(resetPanVerifyData()),
  dispatchResetServicesError: () => dispatch(resetServicesError()),
  dispatchGetMasterDataSkillsModuleAction: (
    data: GetMasterDataListPayloadType
  ) => dispatch(getMasterDataSkillsModuleAction(data)),
  dispatchResetSkillMasterDataList: () => dispatch(resetSkillMasterDataList()),
  dispatchResetSkillsMasterDataTotalCount: () =>
    dispatch(resetSkillsMasterDataTotalCount()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddInternalExternalUser);
